import React, { Component } from 'react';
import ReactGA from 'react-ga';
import {Link} from 'react-router-dom';

ReactGA.initialize('UA-144557614-1');


function initializeGA(){
  ReactGA.pageview('/navbar')
}


const ListProperty = ({name, title, params}) => {
  return(
    <Link className="nav-link nav-toggle" to={{pathname: "/imoveis/" + name, state:{params}}} onClick={()=>interaction('navbar-click', {title})}>{title}</Link>
  );
}

function interaction({mCategory, mType}){
	ReactGA.event({
		category: mCategory,
		action: mType, 

	});
}

export default class Navbar extends Component {

  constructor(props){
    super(props);
    this.list = this.props.info.map(obj => <ListProperty key={obj.id} name={obj.name} title={obj.title} params={obj} />);
    this.state = {
      new_page: false
    }
  }

  componentDidMount(){
    initializeGA();
  }

  render() {

    
    
    return (
      <nav className="topbar topbar-inverse topbar-expand-md topbar-sticky">
      <div className="container">
        <div className="topbar-left">
          <button className="topbar-toggler">☰</button>
          <Link className="topbar-brand" to="/">
            <img className="logo-default" src={`${process.env.PUBLIC_URL}/assets/img/logo_black.png`} alt="logo" />
            <img className="logo-inverse" src={`${process.env.PUBLIC_URL}/assets/img/logo_white.png`} alt="logo" />
          </Link>

        </div>
        <div className="topbar-right">
          <ul className="topbar-nav nav">
            <li className="nav-item">
              <Link className="nav-link nav-toggle" to="/" onClick={()=>interaction('navbar-click', 'home')}>Home</Link>

            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/">Imóveis
                <i className="fa fa-caret-down" />
              </Link>
              <div className="nav-submenu">
                {this.list}
              </div>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/contact-us">Entre em contato</Link>
            </li> */}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/login">Login</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link nav-toggle" to="/about" onClick={()=>interaction('navbar-click', 'about')}>Sobre</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    
  );

  }
}
    




// WEBPACK FOOTER //
// ./src/common/Navbar/index.jsx